export const REQUEST_DOCTOR_SEARCH = 'REQUEST_DOCTOR_SEARCH';
export const REQUEST_DOCTOR_SEARCH_SUCCESS = 'REQUEST_DOCTOR_SEARCH_SUCCESS';
export const REQUEST_DOCTOR_SEARCH_ERROR = 'REQUEST_DOCTOR_SEARCH_ERROR';

export const DOCTOR_LISTING_PAGINATION = 'DOCTOR_LISTING_PAGINATION';

export const REQUEST_BLOG = 'REQUEST_BLOG';
export const REQUEST_BLOG_SUCCESS = 'REQUEST_BLOG_SUCCESS';
export const REQUEST_BLOG_ERROR = 'REQUEST_BLOG_ERROR';

export const CHECK_SCHEDULE_REQUEST = 'CHECK_SCHEDULE_REQUEST';
export const CHECK_SCHEDULE_REQUEST_SUCCESS = 'CHECK_SCHEDULE_REQUEST_SUCCESS';
export const CHECK_SCHEDULE_REQUEST_ERROR = 'CHECK_SCHEDULE_REQUEST_ERROR';